import classNames from 'classnames';
import { ApNiceSelect, EMPTY_OPTION_VALUE } from 'components/ApNiceSelect';
import { InputWithLabel } from 'pages/SingleClaimPage/components/InputWithLabel';
import { useCallback } from 'react';

import { useResolutionExhibitTypeOptions } from '../../../../../../hooks/useResolutionExhibitTypeOptions';
import { useClaimEditableForClient } from '../../../../hooks/useClaimEditableForClient';
import { useSingleClaimContext } from '../../../../providers/SingleClaimProvider';
import './ClaimResolutionSection.css';

export const ClaimResolutionSection = () => {
  const { claim, editField } = useSingleClaimContext();
  const { resolutionTypeId, actionStatus } = claim ?? {};
  const resolutionOptions = useResolutionExhibitTypeOptions();

  const { editableByClient } = useClaimEditableForClient(actionStatus);

  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
    (e) => {
      e.preventDefault();
      const valueNumber = +e.target.value;
      const value = isFinite(valueNumber) ? valueNumber : undefined;

      editField('resolutionTypeId', value);
    },
    [editField],
  );

  return (
    <div className="claim-resolution-section">
      <div className="label">How would you like to proceed with this claim?</div>
      <InputWithLabel
        label="Select which action you would like to take"
        className="single-claim-overview__input-label single-claim-overview__input-label-select"
      >
        <ApNiceSelect
          disabled={!editableByClient}
          className={classNames('category-select__select')}
          onChange={handleChange}
          value={resolutionTypeId || EMPTY_OPTION_VALUE}
          options={resolutionOptions.resolutionStatusOptions}
        />
      </InputWithLabel>
    </div>
  );
};
